export default class Utils {
    static em(pxValue) {
        return (parseInt(pxValue) || 0) / 16;
    }
}



// WEBPACK FOOTER //
// ./src/main/js/utils/Utils.js